// extracted by mini-css-extract-plugin
module.exports = {"TermsConditions":"TermsAndConditions_TermsConditions__rxzqP","name":"TermsAndConditions_name__3RVvk","title":"TermsAndConditions_title__Kh8ZL"};